import React, { Component } from "react";
import PropTypes from "prop-types";

import StreamQuery from "stream/components/StreamQuery";
import ErrorBoundary from "components/Library/ErrorBoundary";
import StreamWithData from "stream/components/StreamWithData";
import { STREAM_TYPE } from "config/constants";

/*
  @TODO: how many stories to ssr for permalinks
*/

export default class Stream extends Component {
  constructor(props) {
    super(props);
    this.state = { isClient: false };
  }

  componentDidMount() {
    this.setState({ isClient: true });
  }

  render() {
    return (
      <ErrorBoundary>
        <StreamQuery
          contentFragment={this.props.contentComponent.fragments.content}
          variables={{
            lookup: this.props.lookup,
            type: this.props.type,
            lastSeen: this.props.lastSeenId,
            streamOverride: this.props.streamOverride,
          }}
          notifyOnNetworkStatusChange={true}
        >
          {({ networkStatus, error, data, fetchMore }) => {
            return (
              <StreamWithData
                networkStatus={networkStatus}
                error={error}
                data={data}
                fetchMore={fetchMore}
                isClient={this.state.isClient}
                {...this.props}
              />
            );
          }}
        </StreamQuery>
      </ErrorBoundary>
    );
  }
}

Stream.propTypes = {
  type: PropTypes.oneOf(Object.values(STREAM_TYPE)).isRequired,
  lookup: PropTypes.string.isRequired,
  onlyShowTitleForA11y: PropTypes.bool,
  defaultCardHeight: PropTypes.number.isRequired,
  contentComponent: PropTypes.func.isRequired,
  lastSeenId: PropTypes.string,
  streamOverride: PropTypes.string,
  showSaveTag: PropTypes.bool,
  noResultsComponent: PropTypes.node,
};
